<template>
  <div class="stop-colors-info cols">
    <table class="popup-details">
      <tbody>
      <tr>
        <td>
          <span class="color-dot color-dot-green"></span>
          {{ $t('generic.green') }}
        </td>
        <td>
          {{ $t('reports.trips.eco-events.stop-colors.duration-range', {
            from: greenStopMinutes,
            to: yellowStopMinutes,
            unit: minutesLabel
          }) }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="color-dot color-dot-yellow"></span>
          {{ $t('generic.yellow') }}
        </td>
        <td>
          {{ $t('reports.trips.eco-events.stop-colors.duration-range', {
            from: yellowStopMinutes,
            to: redStopMinutes,
            unit: minutesLabel
          }) }}
        </td>
      </tr>
      <tr>
        <td>
          <span class="color-dot color-dot-red"></span>
          {{ $t('generic.red') }}
        </td>
        <td>
          {{ $t('reports.trips.eco-events.stop-colors.duration-from', {
            from: redStopMinutes,
            unit: minutesLabel
          }) }}
        </td>
      </tr>
      </tbody>
    </table>

    <div class="rows justify-end pt-10">
      <button type="button" @click="$emit('close')">{{ $t('generic.close') }}</button>
    </div>
  </div>
</template>

<script>
import {dataManipulator} from "@/assets/js/data-manipulation";

export default {
  name: "StopColorsInfoPopup",
  emits: ['close'],
  computed: {
    greenStopMinutes() {
      return this.getStopThresholdMinutes(process.env.VUE_APP_TRIPS_GREEN_STOP_MIN_TIME_SECONDS);
    },
    yellowStopMinutes() {
      return this.getStopThresholdMinutes(process.env.VUE_APP_TRIPS_YELLOW_STOP_MIN_TIME_SECONDS);
    },
    redStopMinutes() {
      return this.getStopThresholdMinutes(process.env.VUE_APP_TRIPS_RED_STOP_MIN_TIME_SECONDS);
    },
    minutesLabel() {
      return this.$t('generic.minutes').toLowerCase();
    },
  },
  methods: {
    getStopThresholdMinutes(seconds) {
      return dataManipulator.convertSecondsToMinutes(Number(seconds ?? 0));
    },
  },
}
</script>

<style scoped lang="scss">
.stop-colors-info {
  min-width: 320px;
}

.popup-details {
  width: 100%;
}

.color-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 8px;
  border-radius: 50%;
  vertical-align: middle;
}

.color-dot-green {
  background-color: #36a853;
}

.color-dot-yellow {
  background-color: #fbbc04;
}

.color-dot-red {
  background-color: #ea4335;
}
</style>
